"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import { X } from "lucide-react";

export default function ImageModal({ src, alt, caption, onClose }) {
  const [visible, setVisible] = useState(true); // show on open

  const closeWithFade = () => {
    setVisible(false);
    setTimeout(onClose, 200); // match transition duration
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") closeWithFade();
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, []);

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-80 flex justify-center items-center transition-opacity duration-400 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      onClick={closeWithFade}
    >
      {/* Close button positioned at the top-right of the image */}
      <button
        onClick={closeWithFade}
        className="absolute top-4 right-4 text-white cursor-pointer z-10"
      >
        <X size={32} />
      </button>

      <div className="flex flex-col items-center max-w-[90vw]">
        <Image
          src={src}
          alt={alt}
          width={1200}
          height={1200}
          className="shadow-2xl object-contain max-h-[85vh] cursor-default"
        />
        {caption && (
          <p className="mt-4 text-white text-center italic max-w-2xl">
            {caption}
          </p>
        )}
      </div>
    </div>
  );
}
